<template>
  <div class="text-xs-center">
    <v-dialog persistent v-model="value.active" width="400" color="red">
      <v-card>
        <v-card-title class="headline red lighten-2" primary-title>{{ value.title }}</v-card-title>

        <v-card-text><h5>{{ value.errorText }}</h5></v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat v-on:click.stop="close">Lukk</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  props: ['value'],
  methods: {
    close: function() {
      this.value.active = false
      this.$emit("close-error");
    }
  }
}
</script>